export default "/images/ic-password.svg?e2a316e345487f955528fe75f02bc89f";